import { ICarrierOutputDto } from './carrier-output-dto.interface';
import { ILocationOutputDto } from './location-output-dto.interface';
import { ISemitrailerOutputDto } from './semi-output-dto.interface';
import { ITagOutputDto } from './tags-output-dto.interface';
import { DeviceTypeEnum, ExternalVehicleAllowedActions } from '../enums';
import { DeviceReportStatusEnum } from '../enums';

interface IDeviceLastReportOutputDto {
    latitude: string | null;
    longitude: string | null;
    geocodedPosition?: string | null;
    timestamp: string | null;
}

export interface IVehicleLastLocationOutputDto {
    locationId?: string | ILocationOutputDto;
    latitude?: number;
    longitude?: number;
    coordinates?: { type: 'Point'; coordinates: [number, number] };
    datetime?: string;
}

export interface IDeviceOutputDto {
    type: DeviceTypeEnum;
    code: string;
    trackerType?: string;
    reportStatus?: DeviceReportStatusEnum;
    lastReport?: IDeviceLastReportOutputDto | null;
    lastReportDate?: string;
}
export interface IVehicleExternalOrganizationsOutputDto {
    organizationId: string;
    allowedActions?: ExternalVehicleAllowedActions[];
}

export interface IVehicleDetails {
    brand?: string;
    model?: string;
    modelYear?: number;
    emptyWeight?: number;
    maxWeight?: number;
    engineType?: string;
}

export interface IVehicleOutputDto {
    id: string;
    organizationId?: string;
    externalId?: string;
    name: string;
    type: string;
    code?: string;
    licensePlate: string;
    device?: IDeviceOutputDto;
    carrier: string | ICarrierOutputDto;
    details?: IVehicleDetails;
    tags?: string[] | ITagOutputDto[];
    status?: string;
    blocked?: boolean;
    createdAt?: string;
    updatedAt?: string;
    externalOrganizations?: IVehicleExternalOrganizationsOutputDto[];
    isExternal?: boolean;
    semitrailers?: (string | ISemitrailerOutputDto)[];
    lastLocation?: IVehicleLastLocationOutputDto;
}

export interface IVehicleExternalOrganizationsOutputDto {
    organizationId: string;
    allowedActions?: ExternalVehicleAllowedActions[];
}
